<template>
  <v-container grid-list-md text-xs-center class="pa-0">
    <v-layout row style="margin-left: 1px; margin-right: 6px;">
      <textarea
              placeholder="Введите заголовок для новой карточки"
              rows="2"
              autofocus
              ref="text"
              persistent-hint
              :required="true"
              :rules="[]"
              class="kanban-textarea"
              v-model="text"
      />
    </v-layout>
    <v-layout row>
      <v-flex xs8>
        <v-btn block class="kanban-btn-ok" @click="ok( text )">Добавить</v-btn>
      </v-flex>
      <v-flex xs4>
        <v-btn block class="kanban-btn-cancel" @click="cancel">Оменить</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {

  name: 'DCardMiniEditor',

  componentName: "DCardMiniEditor",

  /**
   *
   *
   */
  props: {

  },

  /**
   *
   *
   */
  mounted() {

    this.$refs.text.focus()
  },

  /**
   *
   *
   */
  data() {

    return {

      text: ''
    }
  },

  /**
   *
   *
   */
  watch: {

  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     *
     *
     */
    ok( text ) {

      this.$emit( 'ok', text )
    },

    /**
     *
     *
     */
    cancel() {

      this.$emit( 'cancel' )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/DKanban/src/DCardMiniEditor.vue